module.exports = __webpack_public_path__ + "img/cartoon.0d0aab1a.png";